import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail, ArrowRight } from "lucide-react";

export default function CheckEmail() {
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email || "votre adresse email";

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[hsl(228,14%,6%)] p-4">
            <Card className="max-w-md w-full text-center">
                <CardHeader>
                    <div className="mx-auto w-16 h-16 bg-amber-100 dark:bg-amber-950/30 rounded-full flex items-center justify-center mb-4">
                        <Mail className="w-8 h-8 text-amber-600 dark:text-amber-400" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-gray-900 dark:text-white">Vérifiez vos emails</CardTitle>
                    <CardDescription className="text-lg mt-2">
                        Un lien de confirmation a été envoyé à <br />
                        <span className="font-semibold text-gray-900 dark:text-white">{email}</span>
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-gray-600 dark:text-gray-400">
                        Cliquez sur le lien dans l'email pour activer votre compte et commencer à explorer Pépite.
                    </p>
                    <div className="bg-amber-50 dark:bg-amber-950/20 p-3 rounded-lg text-sm text-amber-800 dark:text-amber-300">
                        Pensez à vérifier vos spams si vous ne trouvez pas l'email.
                    </div>
                </CardContent>
                <CardFooter className="flex flex-col gap-3">
                    <Button
                        className="w-full bg-amber-600 hover:bg-amber-700 text-white"
                        onClick={() => navigate('/login')}
                    >
                        Retour à la connexion
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
}
